import styled from 'styled-components';

import Button from '../../../../components/Button/Button';
import SelectDropdown from '../../../../components/SelectDropdown/SelectDropdown';
import { TransportDetailsI } from '../../../../declarations/interfaces/transports';

export const TransportSelectWrapperStyled = styled(SelectDropdown<TransportDetailsI>)`
  .react-select__control {
    height: auto;
    width: 65px;
    padding: 0;
    border: none;
  }

  .react-select__menu {
    min-width: 230px;
  }
`;

export const ButtonStyled = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
`;
